var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostItProcessen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:url(#b);}.f{fill:#b7e1f0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -65.71,
    y1: 612.05,
    x2: -65.71,
    y2: 613.14,
    gradientTransform: "translate(6079.6 55773.29) scale(91.75 -90.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8ddea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9edfa"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "e",
    d: "M100,98.71L0,99.57,.29,.43H98.27l1.73,98.27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "f",
    d: "M98.61,19.23H.24L.29,.43H98.28l.33,18.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostItProcessen);
export default __webpack_public_path__ + "static/media/Post-it-Processen.cc867adc2561bc37949a4a560deee714.svg";
export { ForwardRef as ReactComponent };